// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1709":"9a1f9787","5761":"c2324208","5808":"9a1f9787","8020":"9a1f9787"}[chunkId] + ".chunk.css";
};